import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circleco/compass/components/Modal";
import { Typography } from "@circleco/compass/components/Typography";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { useV4Activation } from "./useV4Activation";

export const ActivationConfirmationModalComponent = () => {
  const modal = useModal();
  const [isActivating, setIsActivating] = useState(false);

  const closeModal = () => {
    void modal.hide();
    modal.remove();
  };

  const { mutate } = useV4Activation({
    showSuccessModal: true,
    redirectTo: "/ai",
    onError: () => setIsActivating(false),
  });

  const handleActivate = () => {
    setIsActivating(true);
    mutate();
  };

  const onOpenChange = (open: boolean) => {
    if (!open && !isActivating) {
      closeModal();
    }
  };

  return (
    <Modal.Root open={modal.visible} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header title={t("activation_confirmation_modal.title")} />
        <Modal.Body>
          <div className="flex flex-col gap-4">
            <Typography variant="body-md" color="primary">
              {t("activation_confirmation_modal.body_paragraph_1")}
            </Typography>
            <Typography variant="body-md" color="primary" component="div">
              <SanitizeHTMLString
                content={t("activation_confirmation_modal.body_paragraph_2")}
                className="[&_strong]:font-semibold"
              />
            </Typography>
          </div>
        </Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: t("activation_confirmation_modal.cancel_text"),
          }}
          primaryAction={{
            label: t("activation_confirmation_modal.cta_text"),
            onClick: handleActivate,
            loading: isActivating,
            disabled: isActivating,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};

const ActivationConfirmationModal = ModalManager.create(() => (
  <ActivationConfirmationModalComponent />
));

export const useActivationConfirmationModal = () =>
  useModal(ActivationConfirmationModal);
